import Vue from 'vue'
import App from './App'
import router from './router.js'
import VueFormLayer from 'vue-form-layer'
import ElementUI from 'element-ui'
import Components from './components'
import VueMarkdown from 'vue-markdown'
import hljs from 'highlight.js'

import 'highlight.js/styles/googlecode.css'
import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/scss/global.scss'

Vue.config.productionTip = false

Vue.use(VueFormLayer)
Vue.use(Components)
Vue.use(ElementUI, {
  size: 'mini'
})
Vue.component('vue-markdown', VueMarkdown)
Vue.directive('highlight', (el) => {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    sidebarShow: false
  },
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js